import { ActionType, createStandardAction, action } from 'typesafe-actions';
import { IModalItem } from 'views/pages/Adas/IncidentsDynamic/IncidentsDynamic.types';

export interface IIncidentType {
  incidentType: number,
  name: string,
  shortName: string,
  color: string,
  isChecked: boolean
};

export interface IIncidentsTypes {
  [key: string]: IIncidentType
}

export interface IAdasState {
  incidentsTypes: IIncidentsTypes;
  adasLayerEnabled: boolean;
  adasRouteAvailable: boolean;
};

const initialState: IAdasState = {
  incidentsTypes: {},
  adasLayerEnabled: false,
  adasRouteAvailable: false
};

export enum actionTypes {
  GET_INCIDENTS_TYPES = 'GET_INCIDENTS_TYPES',
  SET_INCIDENTS_TYPES = 'SET_INCIDENTS_TYPES',
  UPDATE_INCIDENTS_TYPES = 'UPDATE_INCIDENTS_TYPES',
  TOGGLE_ADAS_LAYER = 'TOGGLE_ADAS_LAYER',
  SET_AVAILABILITY_ADAS_ROUTE = 'SET_AVAILABILITY_ADAS_ROUTE'
};

export const adasActions = {
  getIncidentsTypes: createStandardAction(actionTypes.GET_INCIDENTS_TYPES)(),
  setIncidentsTypes: (payload: IIncidentsTypes) => action(actionTypes.SET_INCIDENTS_TYPES, payload),
  updateIncidentsTypes: (payload: IModalItem[]) => action(actionTypes.UPDATE_INCIDENTS_TYPES, payload),
  toggleAdasLayer: (payload: boolean) => action(actionTypes.TOGGLE_ADAS_LAYER, payload),
  setAvailabilityAdas: (payload: boolean) => action(actionTypes.SET_AVAILABILITY_ADAS_ROUTE, payload),
};

type ActionTypes = ActionType<typeof adasActions>;

export const adas = (
  state: IAdasState = initialState,
  action: ActionTypes
): IAdasState => {
  switch (action.type) {
    case actionTypes.SET_INCIDENTS_TYPES:
      return {
        ...state,
        incidentsTypes: action.payload
      };
    case actionTypes.TOGGLE_ADAS_LAYER:
      return {
        ...state,
        adasLayerEnabled: action.payload
      };
    case actionTypes.SET_AVAILABILITY_ADAS_ROUTE:
      return {
        ...state,
        adasRouteAvailable: action.payload
      }
    default:
      return state;
  }
};